import {Suspense} from "react";
import {Helmet} from "react-helmet-async";

import {UpErrorBoundary} from "@/lib/handlers/UpErrorBoundary.tsx";
import {RegisterPageContent} from "@/pages/auth/register/RegisterPageContent.tsx";

import {Layout} from "../layout/Layout.tsx";

export const RegisterPage = () => {
  return (
    <Layout>
      <Helmet>
        <title>Checkout</title>
        <meta
          name="description"
          content="Subscribe to the website monitoring service for unmatched uptime monitoring. Get instant alerts and 24/7 support with Uptime.com."
        />
      </Helmet>
      <UpErrorBoundary>
        <Suspense>
          <RegisterPageContent />
        </Suspense>
      </UpErrorBoundary>
    </Layout>
  );
};
